import { Link } from "react-router-dom";
import styles from "./ArticleCard.module.scss";
import useLang from "hooks/useLang";

export const ArticleCard = ({ id, cardImage, cardTitle, cardText, date, creator }) => {
  const { lang } = useLang()

  return (
    <div className={styles.articleCard}>
      <img src={`${process.env.REACT_APP_API_HOST}${cardImage}`} alt="article" />
      <span className="creator mb-2">
        {creator}
        <span className="date">{date}</span>
      </span>
      {/* <h3 className="title mb-2">Urgensi RUU Konsultan Pajak</h3> */}
      <h3 className={["mb-2", styles.title].join(" ")}>{cardTitle}</h3>
      <p className={["content", styles.description].join(" ")}>{cardText}</p>
      <Link to={`/tax-updates/detail?id=${id}`}>
        <p className="read-more">
          {lang.component.read_more_button} <i className="uil uil-arrow-right" />
        </p>
      </Link>
    </div>
  );
};

export default ArticleCard;
